import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var MailSVG = function MailSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28 6H4a2 2 0 00-2 2v16a2 2 0 002 2h24a2 2 0 002-2V8a2 2 0 00-2-2zm-.3 3.62l-7.44 6.86 6.44 5.9a.9.9 0 010 1.34 1.1 1.1 0 01-1.46 0l-6.45-5.89-2.06 1.89a1.1 1.1 0 01-1.46 0l-2.06-1.89-6.45 5.89a1.1 1.1 0 01-1.46 0 .9.9 0 010-1.34l6.44-5.9L4.3 9.62a.9.9 0 010-1.34 1.1 1.1 0 011.46 0L16 17.7l10.24-9.42a1.1 1.1 0 011.46 0 .9.9 0 010 1.34z"
  }));
};
MailSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MailSVG);